<template>
  <QS-scroller-box>
    <section>
      <QS-h4-title title="退车核算" />
      <template slot="content">
        <!-- 当退车核算需求上线后，计算说明tips需要更新-及时与产品沟通最新tips文案 -->
        <el-popover placement="right-start" width="500" trigger="hover">
          <span v-html="returnAccountingTips"></span>
          <i slot="reference" class="el-icon-info icon-info"></i>
        </el-popover>
      </template>
      <QSColumnBox
        slot="body"
        :source="infoData"
        :list="baseInfoList"
        :separator="columnSeparator"
        label-width="180"
      >
        <template slot="default">
          <template v-if="orderData.state !== 4500">
            <div>
              <div class="el-column-box__title">应退押金:</div>
              <div class="el-column-box__content">
                {{ infoData.refundableDepositAmount || '--' }}元
              </div>
            </div>
            <div>
              <div class="el-column-box__title">应退租金:</div>
              <div class="el-column-box__content">
                {{ infoData.refundableRentAmount || '--' }}元
              </div>
            </div>
            <div>
              <div class="el-column-box__title">需补欠款:</div>
              <div class="el-column-box__content">
                {{ infoData.needPatchAmount || '--' }}元
              </div>
            </div>
          </template>
          <!-- performanceState待履约退车：true展示车辆交接完成时间，false不展示车辆交接完成时间 -->
          <div v-show="infoData.performanceState">
            <div
              class="el-column-box__title"
              style="width: 180px; flex-shrink: 0;"
            >
              车辆交接完成时间:
            </div>
            <div class="el-column-box__content">
              <!-- 核算状态为：1、已完成 2、审批中 3、核算中 情况下禁用 -->
              <!-- :picker-options="pickerOptions" -->
              <el-date-picker
                :disabled="isDisabled"
                v-model="infoData.takeOverTime"
                :picker-options="pickerOptions"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                @change="timeChangeHandle"
                style="width: auto;"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 未足期日租金计算规则显示条件：车辆交接完成时间不显示(待履约订单退车) && 退车核算-订单待核算及以后订单 &&  租金付款方式为：月付（整月）-4 /月付（自然月）-5  -->
          <div
            v-show="
              infoData.performanceState &&
                orderData.state >= 4500 &&
                (Number(orderData.payMode) === 4 ||
                  Number(orderData.payMode) === 5)
            "
          >
            <div
              class="el-column-box__title"
              style="width: 180px; flex-shrink: 0;"
            >
              月付租金未足月计算规则:
            </div>
            <div class="el-column-box__content">
              <!-- 日租规则 0:自然月，1:30天 -->
              <el-select
                v-model="infoData.dailyRule"
                :disabled="isDisabled"
                @change="dailyRuleChange"
              >
                <el-option
                  v-for="item in dailyRuleOption"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div>
            <div class="el-column-box__title">应收租金:</div>
            <div class="el-column-box__content">
              <!-- infoData.receivableAmount === 0 时，0 在js判断时返回false，所以做特殊处理 -->
              {{
                `${(infoData.receivableAmount === 0
                  ? '0.00'
                  : infoData.receivableAmount) ||
                  '--'}元（已收租金：${infoData.toBeReceivedAmount ||
                  '--'}元）`
              }}
            </div>
          </div>

          <div>
            <div class="el-column-box__title">是否结算应退租金:</div>
            <div class="el-column-box__content">
              <el-radio-group v-model="infoData.isSettlementRefund">
                <el-radio :disabled="isDisabled" :label="1">是</el-radio>
                <el-radio :disabled="isDisabled" :label="0">否</el-radio>
              </el-radio-group>
            </div>
          </div>
        </template>
      </QSColumnBox>
    </section>

    <!-- 尽可能不破坏之前props逻辑，后传入isDisabled进行判断 -->
    <operation
      :state="orderData.state"
      :operation="operation"
      :isDisabled="isDisabled"
    ></operation>

    <section v-if="orderData.state === 4500 || orderData.state === 5500">
      <QS-h4-title title="支付款项">
        <template slot="content">
          <el-popover placement="right-start" width="500" trigger="hover">
            <span v-html="paymentTips"></span>
            <i slot="reference" class="el-icon-info icon-info"></i>
          </el-popover>
        </template>
      </QS-h4-title>
      <div class="add-payment-box" v-if="orderData.state === 4500">
        <div class="add-payment-left">
          <span class="label">增加支付项：</span>
          <el-select v-model="selectPaymentVal" placeholder="请选择">
            <el-option
              v-for="item in settleMentFeeFilteredList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <el-button type="primary" :disabled="isDisabled" @click="addPayment"
            >添加</el-button
          >
        </div>
        <div class="add-payment-right">
          <div class="content">
            <span class="title">抵扣运营流水：</span>
            <span class="value"
              >{{ operationFlowDeduct || defaultAmount }}元</span
            >
          </div>
          <div class="content ml16">
            <span class="title">应退押金：</span>
            <span class="value">{{ returnDepositCpt || defaultAmount }}元</span>
          </div>
          <div class="content ml16">
            <span class="title">应退租金：</span>
            <span class="value"
              >{{ returnCarAmountCpt || defaultAmount }}元</span
            >
          </div>
          <div class="content ml16">
            <span class="title">需补欠款：</span>
            <span class="value">{{ needAmountCpt || defaultAmount }}元</span>
          </div>
        </div>
      </div>
      <el-table
        :data="paymentList"
        height="500"
        cell-class-name="custom-cell-class"
      >
        <el-table-column prop="title" label="支付内容" width="110">
        </el-table-column>
        <el-table-column label="付款方" width="100">
          <!-- slot-scope="" 必须写，否则会报错 -->
          <template slot-scope="">{{ orderData.customerName }}</template>
        </el-table-column>
        <el-table-column label="支付金额（元）" width="180">
          <template slot-scope="{ row, $index }">
            <div v-if="orderData.state === 4500">
              <!-- 只有违约金有 切换支付方式 -->
              <div v-if="row.title === '违约金'">
                <!-- 固定金额输入框 -->
                <el-input
                  v-if="isFixed"
                  v-model="row.amount"
                  placeholder="请输入"
                  :disabled="isDisabled"
                  @input="val => moneyBlur(val, $index, true)"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
                <!-- 按核算比例输入框 + 提示 -->
                <div v-else>
                  <el-input
                    v-number:percent
                    v-model="percent"
                    placeholder="请输入"
                    :disabled="isDisabled"
                    @input="val => moneyPercentBlur(val, $index)"
                  >
                    <template slot="append"
                      >%</template
                    >
                  </el-input>
                  <div class="tips" style="padding-left: 0;">
                    <p>
                      剩余租期租金：{{
                        infoData.surplusReceivableAmount || '0.00'
                      }}
                      元
                    </p>
                    <p>当前比例违约金金额：{{ row.amount || '0.00' }}元</p>
                    <p
                      class="el-icon-info"
                      v-show="Number(infoData.surplusReceivableAmount) === 0"
                    >
                      &nbsp;当前租期剩余租金为0，无法按比例结算
                    </p>
                  </div>
                </div>
                <!-- @click="isFixed = !isFixed" -->
                <el-button
                  :disabled="isDisabled"
                  @click="changeInputHandle($index)"
                  class="mt16"
                  type="text"
                  icon="el-icon-s-operation"
                >
                  {{ changeBtnText }}
                </el-button>
              </div>
              <!-- 除了违约金其他行的固定金额输入框 -->
              <el-input
                v-else
                v-model="row.amount"
                placeholder="请输入"
                :disabled="isDisabled"
                @input="val => moneyBlur(val, $index)"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </div>
            <div v-if="orderData.state === 5500">
              {{ row.amount || '0.00' }}元
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="280px">
          <template slot-scope="{ row }">
            <div v-if="orderData.state === 4500">
              <el-input
                :disabled="isDisabled"
                v-model="row.remarks"
                type="textarea"
                placeholder="请输入备注"
                maxlength="500"
                show-word-limit
              >
              </el-input>
            </div>
            <div v-if="orderData.state === 5500">
              {{ row.remarks || '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="400">
          <template slot-scope="{ row }">
            <div v-if="orderData.state === 4500">
              <div v-if="isDisabled" class="box-photos">
                <div
                  class="item"
                  v-for="(item, index) in row.photos"
                  :key="index"
                >
                  <EnlargeImg :imgSrc="item.url" />
                </div>
              </div>
              <UploadCommon
                v-else
                :fileList="row.photos"
                :limit="3"
                :showUploadBtnByLimit="3"
                :isAlone="false"
                :isShowTitle="false"
                :sizeType="4"
              >
              </UploadCommon>
            </div>
            <div v-if="orderData.state === 5500" class="box-photos">
              <div
                class="item"
                v-for="(item, index) in row.photos"
                :key="index"
              >
                <EnlargeImg :imgSrc="item.url" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
          v-if="orderData.state === 4500"
        >
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              v-if="row.isHandle && !isDisabled"
              @click="handleDelete($index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 订单状态 0:待确认，1500:待出库，2500:履约中，3500:待入库，4500:核算中，5500:已关闭 -->
    <template slot="bottomAction" v-if="orderData.state === 4500">
      <el-button size="small" @click="toBackPage">取消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="saveInfo"
        v-show="!isDisabled"
        >保存</el-button
      >
      <template v-if="!isDisabled">
        <el-button
          type="primary"
          size="small"
          @click="submitInfo"
          :loading="submitLoading"
          >提交</el-button
        >
        <!-- <el-button type="primary" size="small" @click="submitInfo" v-if="!dingTalkShow" >提交</el-button>
        <el-button type="primary" size="small" @click="submitInfo" v-else>提交钉钉审批</el-button> -->
      </template>
    </template>
    <!-- 0 待核算 / 1 已完成 / 2 审批中 / 3 核算中 / 4 核算失败 -->
    <!-- 只有审批中 有 查看审批状态 -->
    <template slot="bottomAction" v-if="infoData.settlementState === 2">
      <el-button @click="lookApproval">查看审批动态</el-button>
    </template>
    <LookApprovalDetail
      ref="lookApprovalDetail"
      :bizId="this.bizId"
      :bizType="getBizType"
    ></LookApprovalDetail>
  </QS-scroller-box>
</template>

<script>
import { vehiclesettlement } from '@/api/domain/finance'
import {
  addSettlement,
  calculateReceivableAmount,
  confirmSettlement,
} from '@/api/domain/orders'
import * as globalApi from '@/api/global'
import LookApprovalDetail from '@/pages/approvals/components/lookApprovalDetail.vue'
import { limitMoreZero, limitMoreZeroByPercent } from '@/utils/validate'
import _cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { mapState } from 'vuex'
import operation from './operation.vue'
// tips 提示
import { paymentTips, returnAccountingTips } from './tooltips'

// 记录开始时间
let startDate = ''

export default {
  components: {
    operation,
    LookApprovalDetail,
  },
  data() {
    const settlementStateMap = {
      0: '待核算',
      1: '已完成',
      2: '审批中',
      3: '核算中',
      4: '核算失败',
    }
    return {
      pickerOptions: {
        disabledDate(date) {
          // 服务端返回的开始时间之前不能选择、不能选择未来时间
          return (
            date.getTime() < new Date(startDate).getTime() - 8.64e7 ||
            date.getTime() > Date.now()
          )
        },
      },
      isFixed: true, // 支付方式  固定金额: true, 按核算比例：false
      percent: '0.00', // 违约金 百分比
      baseInfoList: [
        {
          key: 'returnType',
          name: '退车类型',
        },
        {
          key: 'orderStatus',
          name: '订单状态',
        },
        {
          key: 'inventoryStatus',
          name: '库内状态',
        },
        {
          key: 'accidentCount',
          name: '相关事故',
        },
        {
          key: 'maintenanceCount',
          name: '维保状态',
        },
        {
          key: 'violationCount',
          name: '违章状态',
        },
        {
          key: 'settlementReason',
          name: '退车原因',
        },
        {
          key: 'receivableDeposit',
          name: '应收押金',
          getValue: (infoData) =>
            `${infoData.receivableDeposit ||
              '--'}元（已收押金：${infoData.receivedDeposit || '--'}元）`,
        },
        {
          key: 'settlementState',
          name: '核算状态',
          getValue: (infoData) => {
            return settlementStateMap[infoData.settlementState] || '--'
          },
        },
        // {
        //   key: 'receivableAmount',
        //   name: '应收租金',
        //   getValue: (infoData) =>
        //     `${infoData.receivableAmount || '--'}元（已收租金：${
        //       infoData.toBeReceivedAmount || '--'
        //     }元）`,
        // },
      ],
      paymentList: [],
      orderId: '',
      infoData: {},
      selectPaymentVal: null,
      operation: {
        amount: '0.00',
        remark: '',
        photos: [],
      },
      defaultAmount: '0.00',
      dingTalkShow: false,
      bizId: '', // 查看动态审批需要传递的参数
      returnAccountingTips, // 退车核算计算说明
      paymentTips, // 支付款项计算说明
      dailyRuleOption: [
        { label: '期始月份自然天数计算', value: 0 },
        { label: '每月30天计算', value: 1 },
      ],
      submitLoading: false,
    }
  },
  inject: ['orderData', 'getDetails'],
  methods: {
    changeInputHandle(index) {
      if (this.isFixed) {
        // 初始化比例， 在切换的时候触发
        this.moneyBlur(this.paymentList[index].amount, index, true)
      }
      this.isFixed = !this.isFixed
      if (!this.isFixed) {
        const current = Number(this.paymentList[index].amount)
        const total = Number(this.infoData.surplusReceivableAmount)

        if (current > total) {
          this.paymentList[index].amount = total
          console.log(this.paymentList[index])
          this.$set(this.paymentList, index, this.paymentList[index])
        }
      }
    },
    // 固定金额 input事件 计算
    moneyBlur(value, index, isDefault) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      limitMoreZero(
        value,
        (res) => {
          self.paymentList[index].amount = res
          // 违约金字段才计算比例
          if (isDefault) {
            // 比例 = 违约金金额 / 剩余租期租金
            if (Number(self.infoData.surplusReceivableAmount) === 0) {
              self.percent = '0.00'
            } else {
              let num =
                (Number(self.paymentList[index].amount) /
                  Number(self.infoData.surplusReceivableAmount)) *
                100
              num = num > 100 ? 100 : num // 违约金金额 = 剩余租期租金 * 已输入的比例
              self.percent = num.toFixed(2)
              // self.percent = ((Number(self.paymentList[index].amount) / Number(self.infoData.surplusReceivableAmount)) * 100).toFixed(2)
            }
          }
        },
        7,
      )
    },
    // 按比例 input 事件 计算
    moneyPercentBlur(value, index) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      limitMoreZeroByPercent(value, (res) => {
        if (Number(self.infoData.surplusReceivableAmount) === 0) {
          self.percent = '0.00'
        } else {
          self.percent = res
          // 违约金金额 = 剩余租期租金 * 已输入的比例
          self.paymentList[index].amount = (
            Number(self.infoData.surplusReceivableAmount) *
            (Number(res) / 100)
          ).toFixed(2)
        }
      })
    },
    getInfo(orderId) {
      if (!orderId) return
      vehiclesettlement({ orderId })
        .then((res) => {
          if (res.code === 1) {
            const infoData = res.data || {}
            this.infoData = infoData
            // 运营情况
            this.operation.amount = infoData.operationFlowAmount
            this.operation.remark = infoData.operationFlowRemarks
            this.operation.photos = Array.isArray(infoData.operationFlowPhotos) ? infoData.operationFlowPhotos : this.getURL({ data: infoData.operationFlowPhotos, defaultImg: [], needName: true })
            // 支付款项
            this.paymentList = infoData.orderSettlementItems.map((item) => {
              if (item.fixFlag) {
                item.isHandle = false
              } else {
                item.isHandle = true
              }
              item.type = item.payContent
              item.title = (
                this.settleMentFeeList.filter(
                  (v) => v.code === item.payContent,
                )[0] || {}
              ).name
              item.photos = Array.isArray(item.photos) ? item.photos : this.getURL({ data: item.photos, defaultImg: [], needName: true })
              return item
            })
            this.bizId = infoData.bizId
            // 给日期组件禁用使用
            startDate = infoData.startDate
            this.infoData.dailyRule = infoData.dailyRule || 0
          }
        })
    },
    // 添加支付项
    addPayment() {
      if (!this.selectPaymentVal) {
        this.$message.warning('请添加支付项')
        return
      }
      const label = (
        this.settleMentFeeList.filter(
          (item) => item.code === this.selectPaymentVal,
        )[0] || {}
      ).name
      const { sort } = this.settleMentFeeList.filter(
        (item) => item.code === this.selectPaymentVal,
      )[0] || {}
      const findPaymentVal = this.paymentList.filter(
        (item) => item.type === this.selectPaymentVal,
      )
      if (findPaymentVal.length !== 0) {
        this.$message.warning('请勿添加重复的支付项')
        return
      }
      const data = {
        sort,
        title: label,
        type: this.selectPaymentVal,
        amount: '0.00',
        remarks: '',
        photos: [],
        isHandle: true,
      }
      this.paymentList.push(data)
    },
    // 删除支付项
    handleDelete(index) {
      this.paymentList.splice(index, 1)
    },
    handleInfo() {
      const param = {
        orderId: this.orderId,
        settlementItems: [],
        refundableDepositAmount: this.returnDepositCpt, // 应退押金
        needPatchAmount: this.needAmountCpt, // 需补欠款
        receivableDeposit: this.infoData.receivableDeposit || 0, // 应收押金
        receivedDeposit: this.infoData.receivedDeposit || 0, // 已收押金
        receivableAmount: this.infoData.receivableAmount || 0, // 应收租金
        toBeReceivedAmount: this.infoData.toBeReceivedAmount || 0, // 已收租金
        refundableRentAmount: this.returnCarAmountCpt || 0, // 应退租金
        approvalAccessModeType: this.dingTalkShow ? 2 : '', // 审批模式类型  2-提交钉钉审批 只有提交钉钉审批传 2其他都传 空
        takeOverTime: this.infoData.takeOverTime, // 车辆交接完成时间
        isRentCarSettlement: this.infoData.isSettlementRefund, // 是否结算应退租金 1-是 0-否
        operationFlowDeduct: this.operationFlowDeduct, // 抵扣运营流水
        dailyRule: this.infoData.dailyRule, // 未足期日租金计算规则 0-期始月份自然天数计算 1-每月30天计算
      }

      // 运营情况
      param.operationFlowAmount = this.operation.amount || 0
      this.operation.remark &&
        (param.operationFlowRemarks = this.operation.remark)
      this.operation.photos.length !== 0 &&
        (param.operationFlowPhotos = this.operation.photos.map((item) => {
          return {
            name: item.name,
            url: item.url,
          }
        }))
      // 支付款项
      param.settlementItems = this.paymentList.map((item) => {
        const itemPhotos = this.getUoloadCommonFileData(item.photos)
        return {
          payContent: item.type,
          sort: item.sort,
          amount: item.amount,
          remarks: item.remarks,
          photos: itemPhotos,
        }
      })
      return param
    },
    saveInfo() {
      console.log('----this.infoData.takeOverTime', this.infoData.takeOverTime)
      const { infoData } = this
      // infoData.performanceState-退车待履约/履约中为true时校验车辆完成交接时间，false时不校验车辆完成交接时间
      if (infoData.performanceState && !infoData.takeOverTime) {
        this.$message.error('车辆完成交接时间不能为空！')
        return
      }
      addSettlement({ ...this.handleInfo() }).then((res) => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          this.$router.push('/workbench/rentOrder/list')
        }
      })
    },
    submitInfo() {
      const { infoData } = this
      // infoData.performanceState-退车待履约/履约中为true时校验车辆完成交接时间，false时不校验车辆完成交接时间
      if (infoData.performanceState && !infoData.takeOverTime) {
        this.$message.error('车辆完成交接时间不能为空！')
        return
      }
      try {
        this.getDingTalkBtnStatus()
      } catch (error) {
        this.submitLoading = false
      }
    },
    toBackPage() {
      const { orderType = '' } = this.$route.query
      this.$refreshBack(false)
      if (orderType === 'enterChild') {
        // 如果是通过企业子订单跳转过来的详情，再跳回去企业租赁子订单列表
        this.$router.push('/workbench/entOrder/list?listType=child')
      } else {
        this.$router.push('/workbench/rentOrder/list')
      }
    },
    // 查询钉钉审批是否开通
    async getDingTalkBtnStatus() {
      // bizType-业务类型
      const { code, data } = await globalApi.getSubmitDingTalkShow({
        bizType: this.getBizType,
      })
      this.submitLoading = true
      this.dingTalkShow = data
      if (code !== 1) {
        this.submitLoading = false
        return
      }
      if (data) this.payStateOpen()
      else this.payStateNoOpen()
    },
    // 查看审批动态
    lookApproval() {
      // this.infoData.bizId
      this.$refs.lookApprovalDetail.dialogVisible = true
    },
    // 时间change
    timeChangeHandle(val) {
      this.infoData.takeOverTime = val
        ? moment(val).format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.calculateReceivableAmount()
    },
    // 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
    async calculateReceivableAmount() {
      const { code, data } = await calculateReceivableAmount({
        orderId: this.orderId,
        takeOverTime: this.infoData.takeOverTime,
        dailyRule: this.infoData.dailyRule, // 未足期日租金计算规则
      })
      if (code === 1) {
        this.infoData.surplusReceivableAmount =
          data && data.surplusReceivableAmount
        this.infoData.receivableAmount = data && data.receivableAmount
      }
    },
    // 未足期日租金计算规则change
    dailyRuleChange() {
      this.calculateReceivableAmount()
    },

    // “租赁退车付款审批”或“租赁退车付款审批”的状态未开启,订单直接流转到“费用待结算”状态
    payStateNoOpen() {
      this.$confirm(
        '确认后将提交到财务核算，将无法再次修改金额',
        '确认是否提交',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        },
      )
        .then(() => {
          this.submitAjax(false)
        })
        .catch(() => {
          this.submitLoading = false
        })
    },
    // “租赁退车付款审批”或“租赁退车付款审批”的状态已开启
    payStateOpen() {
      this.$confirm(
        '确认后将提交审批，无法再次修改金额，财务审批通过后才可进行费用结算',
        '确认是否提交',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        },
      )
        .then(() => {
          this.submitAjax(true)
        })
        .catch(() => {
          this.submitLoading = false
        })
    },
    // 提交接口请求
    async submitAjax(isOpen) {
      const { code } = await confirmSettlement({ ...this.handleInfo() })
      if (code === 1) {
        this.$message.success('提交成功')
        this.submitLoading = false
        const { orderType } = this.$route.query
        const path =
          orderType === 'enterChild'
            ? '/workbench/entOrder/detail/child'
            : '/workbench/rentOrder/detail'
        const query = {
          id: this.orderId,
          type: orderType === 'enterChild' ? 1 : 8,
        }
        // 如果是钉钉审批流不进行跳转，只更新当前页面状态
        if (!isOpen) this.$router.push({ path, query })
        this.$nextTick(() => {
          window.location.reload()
        })
      } else if (code === 24012) {
        this.submitLoading = false
        // 网约钱包支付提示
        this.$confirm(
          '有正在进行中的网约钱包支付,可等待网约钱包支付完成后再进行核算或手动终止',
          '提示',
          {
            confirmButtonText: '去终止',
            cancelButtonText: '取消',
          },
        ).then(() => {
          // TODO: 待确认id
          this.$router.push({
            path: '/finance/withholdPlanList',
          })
        })
      } else if (code === 24013) {
        this.submitLoading = false
        // 支付宝支付提示
        this.$alert(
          '有正在进行中的支付宝支付,请完成支付宝支付后再进行核算',
          '提示',
          {
            confirmButtonText: '关闭',
            callback: () => {
              this.submitLoading = false
            },
          },
        )
      } else {
        this.submitLoading = false
      }
    },
  },
  computed: {
    ...mapState({
      settleMentFeeList: (state) => state.global.settleMentFeeList, // 结算费项
    }),
    // 页面增加支付费项的枚举 需要过滤掉接口返回的几个费项目 和 1-租金、2-押金
    settleMentFeeFilteredList() {
      let na = []
      const settleMentFeeListClone = _cloneDeep(this.settleMentFeeList)
      let codeList = this.paymentList.reduce((total, i) => {
        return total.concat(i.type)
      }, [])
      codeList = codeList.concat([1, 2])
      if (codeList && codeList.length > 0) {
        na = settleMentFeeListClone.filter(
          (item) => !codeList.includes(item.code),
        )
      }
      return na
    },
    // 违约金按钮切换文案
    changeBtnText() {
      return this.isFixed ? '按比例核算' : '固定金额'
    },
    // 车辆交接完成时间、是否结算应退租金 是否禁用
    isDisabled() {
      // <!-- 核算状态为：1、已完成 2、审批中 3、核算中 情况下禁用 -->
      if (
        this.infoData.settlementState === 1 ||
        this.infoData.settlementState === 2 ||
        this.infoData.settlementState === 3 ||
        this.orderData.state !== 4500
      ) {
        return true
      }
      return false
    },
    /**
     * 以下计算属性都是本页面需要前端参与计算的
     */
    // 1. 支付款项：表格所有列之和
    paymentAmountCpt() {
      let paymentAmountSum = 0
      this.paymentList.forEach((item) => {
        paymentAmountSum += Number(item.amount)
      })
      return Number(paymentAmountSum.toFixed(2))
    },
    // 2. 需补租金：应收租金 - 已收租金 > 0 ? 计算后的值 : 0
    needCarAmountCpt() {
      const amount =
        this.infoData.receivableAmount - this.infoData.toBeReceivedAmount
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 3. 剩余应退押金：已收押金 - 需补租金 > 0 ? 计算后的值 : 0
    residueReturnDepositCpt() {
      const amount = this.infoData.receivedDeposit - this.needCarAmountCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 4. 应退押金：剩余应退押金 - 支付款项 > 0 ? 计算后的值 : 0
    returnDepositCpt() {
      const amount = this.residueReturnDepositCpt - this.paymentAmountCpt
      return amount > 0 ? amount.toFixed(2) : 0
    },
    // 5. 剩余支付款项：支付款项 - 剩余应退押金 > 0 ? 计算后的值 : 0
    residuePaymentAmountCpt() {
      const amount = this.paymentAmountCpt - this.residueReturnDepositCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    /**
     * 6. 应退租金：
     *      a.是否结算应退租金(是) => 已收租金 - 应收租金 - 剩余支付款项 > 0 ? 计算后的值 : 0
     *      b.是否结算应退租金(否) => 0
     */
    returnCarAmountCpt() {
      const amount = this.infoData.isSettlementRefund
        ? this.infoData.toBeReceivedAmount -
          this.infoData.receivableAmount -
          this.residuePaymentAmountCpt
        : 0
      return amount > 0 ? amount.toFixed(2) : 0
    },
    /**
     * 7. 需补欠款：
     *      a.是否结算应退租金(是) => 支付款项 - 已收押金 - (已收租金 - 应收租金) > 0 ? 计算后的值 : 0
     *      b.是否结算应退租金(否) => 已收租金 - 应收租金 < 0 ? 直接走 条件 a : (支付款项 - 已收押金 ? 计算后的值 : 0)
     */
    needAmountCpt() {
      const aCount =
        this.paymentAmountCpt -
        this.infoData.receivedDeposit -
        (this.infoData.toBeReceivedAmount - this.infoData.receivableAmount)
      let amount = 0
      if (this.infoData.isSettlementRefund) {
        amount = aCount
      } else if (
        this.infoData.toBeReceivedAmount - this.infoData.receivableAmount <
          0
      ) {
        amount = aCount
      } else {
        amount = this.paymentAmountCpt - this.infoData.receivedDeposit
      }
      amount -= this.operationFlowDeduct // 减去抵扣运营流水
      // const amount = this.paymentAmountCpt - this.infoData.receivedDeposit - (this.infoData.toBeReceivedAmount - this.infoData.receivableAmount)
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    /** *
      8.抵扣运营流水
            a.是否结算应退租金(是) => 运营流水 - 支付款项-  已收押金-(已收租金 - 应收租金)  > 0 ? 支付款项-(已收租金 - 应收租金)   : 运营流水
           b.是否结算应退租金(否) => 运营流水 - 已收押金- 剩余支付款项
    */
    operationFlowDeduct() {
      // this.operation.amount
      const num = (this.operation.amount && Number(this.operation.amount)) || 0
      // 支付款项- 已收押金-(已收租金 - 应收租金)
      const aCount =
        this.paymentAmountCpt -
        this.infoData.receivedDeposit -
        (this.infoData.toBeReceivedAmount - this.infoData.receivableAmount)
      let amount = 0
      // 是否应退租金
      if (this.infoData.isSettlementRefund) {
        amount = aCount
      } else {
        // 已收租金 - 应收租金
        // eslint-disable-next-line no-lonely-if
        if (
          this.infoData.toBeReceivedAmount - this.infoData.receivableAmount <
          0
        ) {
          amount = aCount
        } else {
          // 支付款项 - 已收押金
          amount = this.paymentAmountCpt - this.infoData.receivedDeposit
        }
      }
      // 抵扣运营流水 = 运营流水 - 最终款项>0 ? 最终款项 : 运营流水
      const data = num - amount > 0 ? amount : num
      return data > 0 ? Number(data.toFixed(2)) : 0
    },
    /*
        向后端传递的参数（判断是应收/应付） bizType
        需补欠款大于 0 -- 应收审批
        应退押金 或 应退租金 大于 0 -- 应付审批
        需补欠款、应退押金、应退租金 都等于 0 -- 应收审批
        bizType 1 个人租赁应收审批 / 2租赁退车付款审批 / 3租赁退车收款审批 / 4支付宝支付解约 / 5网约钱包支付解约
      */
    getBizType() {
      let bizType
      if (
        this.needAmountCpt > 0 ||
        (this.needAmountCpt === 0 &&
          this.returnDepositCpt === 0 &&
          this.returnCarAmountCpt === 0)
      ) {
        bizType = 3
      } else if (this.returnDepositCpt > 0 || this.returnCarAmountCpt > 0) {
        // 应退押金 或 应退租金
        bizType = 2
      }
      return bizType
    },
  },
  async created() {
    await this.$store.dispatch('getPaymentMethods', {
      type: 'settlementFeeType',
    }) //  结算费项枚举
    const orderId = this.$route.query.id
    this.orderId = orderId
    this.getInfo(orderId)
    // this.getDingTalkBtnStatus()
    this.getDetails()
  },
}
</script>
<style lang="scss" scoped>
.add-payment-box {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 20px;

  .add-payment-right {
    display: flex;
  }
}

::v-deep .custom-cell-class {
  vertical-align: top;

  .cell {
    padding-top: 10px;
  }
}
.box-photos {
  display: flex;
  flex-wrap: wrap;

  .item {
    margin-left: 16px;
    width: 80px;
    height: 80px;

    &:nth-child(5n + 1) {
      margin-left: 0;
    }

    &:nth-child(n + 6) {
      margin-top: 30px;
    }
  }
}
.item-flex {
  // 兼容处理，flex盒子
  display: -webkit-box;
  display: -moz-box;
  width: 100%;
  ::v-deep .el-input__suffix {
    height: 32px;
    line-height: 32px;
  }
}
</style>
